import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogResult } from 'src/app/models/dialog-result';
import { IProduct } from 'src/app/models/products/product';
import { IProductRef } from 'src/app/models/products/actions/settings/transferProductSettings';

export interface SelectProductsStepData {
  products: IProduct[];
  masterSuiteSourceId: string;
  sourceEnhancementVariantId: string;
}

export interface SelectProductsStepResult {
  products: IProductRef[];
}

@Component({
  selector: 'app-select-products-step',
  templateUrl: './select-products-step.component.html',
  styleUrls: ['./select-products-step.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class SelectProductsStepComponent {
  readonly selection = new SelectionModel<IProduct>(true, []);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SelectProductsStepData,
    private readonly dialogRef: MatDialogRef<SelectProductsStepComponent>,
  ) {}

  get availableProducts(): IProduct[] {
    return this.data.products.filter((product) =>
      product.masterSuiteId === this.data.masterSuiteSourceId
      && product.masterSuiteEnhancementVariantId === this.data.sourceEnhancementVariantId,
    );
  }

  toggle(product: IProduct): void {
    this.selection.toggle(product);
  }

  isSelected(product: IProduct): boolean {
    return this.selection.isSelected(product);
  }

  hasSelection(): boolean {
    return this.selection.hasValue();
  }

  isAllSelected(): boolean {
    const available = this.availableProducts;
    return available.length > 0 && this.selection.selected.length === available.length;
  }

  isIndeterminate(): boolean {
    return this.selection.hasValue() && !this.isAllSelected();
  }

  toggleAll(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.availableProducts);
  }

  selectedCount(): number {
    return this.selection.selected.length;
  }

  availableCount(): number {
    return this.availableProducts.length;
  }

  confirm(): void {
    if (!this.hasSelection()) return;
    this.dialogRef.close({
      products: this.selection.selected.map((product) => ({ id: product.id! })),
    } as SelectProductsStepResult);
  }

  cancel(): void {
    this.dialogRef.close(DialogResult.Cancel);
  }
}
